import { convertStyleData, transformPx2Rem } from '@utils/tools';

import { appMethod as app } from '@utils/app';

import './AddressEleCustomComponent.less';

export default function AddressEleCustomComponent(props) {
  /**
   * 传入数据
   */ 
  const data = props.data;                // 组件数据
  const detailData = props.detailData;    // 详情页数据
  const dynamicData = props.dynamicData;  // 动态数据
  const formCompindex = props.formCompindex;    // 动态表单索引
  /**
   * 组件配置对象
   */  
  const customFeature = data.customFeature;
  /**
   * 样式数据处理
   */
  const styleObj = convertStyleData(data.style);
  const titleObj = {
    height: transformPx2Rem(customFeature.titleStyle['line-height'], 320),
    color: customFeature.titleStyle.color,
    backgroundColor: customFeature.titleStyle['background-color'],
    fontSize: transformPx2Rem(customFeature.titleStyle['font-size'], 320),
    lineHeight: transformPx2Rem(customFeature.titleStyle['line-height'], 320),
    fontWeight: customFeature.titleStyle['font-weight'],
    fontStyle: customFeature.titleStyle['font-style'],
    textDecoration: customFeature.titleStyle['text-decoration'],
    textAlign: customFeature.titleStyle['text-align'],
  };
  const selectAddressObj = {
    height: transformPx2Rem(customFeature.contentStyle['line-height'], 320),
    color: customFeature.contentStyle.color,
    backgroundColor: customFeature.contentStyle['background-color'],
    fontSize: transformPx2Rem(customFeature.contentStyle['font-size'], 320),
    lineHeight: transformPx2Rem(customFeature.contentStyle['line-height'], 320),
    fontWeight: customFeature.contentStyle['font-weight'],
    fontStyle: customFeature.contentStyle['font-style'],
    textDecoration: customFeature.contentStyle['text-decoration'],
    textAlign: customFeature.contentStyle['text-align'],
  };
  /**
   * 组件内容处理
   */   
  let content = data.content;
  const segment = customFeature.segment; // 已绑定字段
  // 是否有绑定字段
  if (segment) {
    if (detailData && detailData[segment]) {
      content = detailData[segment];    // 当前组件处于详情页数据并已绑定某字段
    } else if (dynamicData && dynamicData[segment]) {
      content = dynamicData[segment];   // 当前组件有动态数据并已绑定某字段（TODO: 如果content为富文本，需要处理）
    }
  }
  /**
   * 绑定事件
   */
  function formAddress() {
    let pageInstance = app.getAppCurrentPage();
    let compindex = formCompindex;
    let formcompindex = props.index;
    let syncUserAddress = customFeature.syncUserAddress;
    let filed = customFeature.segment;
    app.turnToPage('myAddress?from=form&syncUserAddress=' + syncUserAddress);
    // TODO 页面返回后进行回调设置(需要解决页面返回可回调处理的问题/处理前一个页面的实例)
    pageInstance.selectAddressCallback = (res) => {
      let newdata = {};
      let address = res.address_info.province.text + res.address_info.city.text + res.address_info.district.text + res.address_info.detailAddress;
      newdata['eles[' + formcompindex +'].content[' + compindex + '].' + filed] = address
      pageInstance.setData(newdata);
    }
  }
  /**
   * 返回组件
   */ 
  return (
    <div className="custom-component address-ele" style={styleObj}>
      <div className="title" style={titleObj}>{customFeature.name}</div>
      <div className="select-address" style={selectAddressObj} onClick={formAddress}>
        {'请选择地区'}
        <span className="ico-moon icon-rightarrow"></span>
      </div>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/custom-component/address-ele-custom-component/AddressEleCustomComponent.jsx